angular.module('elfium').controller('companyDetailModalController', ['$scope', '$uibModalInstance', '$timeout', '$q', 'companyService', 'elfiumToastrService', 'elfiumModalFactory', 'elfiumLoginService', 'elfiumRelatedOptionsService', 'elfiumMissingRequiredFieldsFilter', 'companyId', 'companyHasOtherAddressFilter', 'ELFIUM_SELECT_OPTIONS', 'COMPANY_REQUIRED_FIELDS',
    function ($scope, $uibModalInstance, $timeout, $q, companyService, elfiumToastrService, elfiumModalFactory, elfiumLoginService, elfiumRelatedOptionsService, elfiumMissingRequiredFieldsFilter, companyId, companyHasOtherAddressFilter, ELFIUM_SELECT_OPTIONS, COMPANY_REQUIRED_FIELDS) {
        var that = this;
        that.elfiumModal = null;
        $scope.selectOptions = ELFIUM_SELECT_OPTIONS;
        $scope.krajOptions = {
            adresa: [],
            fakturacniAdresa: []
        };
        that.init = function () {
            that.getCompany().then(function (company) {
                $scope.company = company;
                that.elfiumModal = new elfiumModalFactory($scope, $uibModalInstance, company);
                that.initializeWatches();
            }, elfiumToastrService.error);
            that.getRelatedOptions();
        };
        that.getCompany = function () {
            var company = null;
            if (companyId) {
                company = that.loadCompany(companyId);
            } else {
                company = that.buildCompany();
            }
            return $q.when(company);
        };
        that.loadCompany = function (companyId) {
            return companyService.getCompany(companyId);
        };
        that.buildCompany = function () {
            return {
                adresa: {
                    zeme: ELFIUM_SELECT_OPTIONS.zeme.cesko
                },
                aktivni: true,
                userId: elfiumLoginService.getUserId()
            };
        };
        that.getRelatedOptions = function () {
            elfiumRelatedOptionsService.getUserOptions().then(function (userOptions) {
                $scope.userOptions = userOptions;
            }, elfiumToastrService.error);
        };
        that.upsertCompany = function () {
            companyService.upsertCompany($scope.company).then(function () {
                that.elfiumModal.mainObjectSaved();
                elfiumToastrService.success('Firma byla uložena!');
                $uibModalInstance.close();
            }, elfiumToastrService.error);
        };
        that.checkIfZkratkaValueUnique = function (zkratkaValue) {
            $scope.isZkratkaFieldValueNotUnique = true;
            companyService.isZkratkaFieldValueNotUnique($scope.company.id, zkratkaValue).then(function (isZkratkaFieldValueNotUnique) {
                $scope.isZkratkaFieldValueNotUnique = isZkratkaFieldValueNotUnique;
            }, elfiumToastrService.error);
        };
        that.setKrajOptionsForCountry = function (optionName, zeme) {
            switch(zeme) {
                case ELFIUM_SELECT_OPTIONS.zeme.cesko:
                    $scope.krajOptions[optionName] = ELFIUM_SELECT_OPTIONS.krajCZ;
                    break;
                case ELFIUM_SELECT_OPTIONS.zeme.slovensko:
                    $scope.krajOptions[optionName] = ELFIUM_SELECT_OPTIONS.krajSK;
                    break;
                default:
                    $scope.krajOptions[optionName] = [];
            }
        };
        that.prefillOtherAddress = function () {
            that.assignOtherAddress(angular.copy($scope.company.adresa));
        };
        that.resetOtherAddress = function () {
            that.assignOtherAddress({
                ulice: '',
                cisloPopisne: '',
                mesto: '',
                psc: '',
                kraj: '',
                zeme: ''
            });
        };
        that.assignOtherAddress = function (otherAddress) {
            $scope.company.fakturacniAdresa = otherAddress;
            if ($scope.company.fakturacniAdresaId) {
                $scope.company.fakturacniAdresa.id = $scope.company.fakturacniAdresaId;
            }
        };
        $scope.getZkratkaFieldClass = function () {
            return $scope.isZkratkaFieldValueNotUnique ? 'xeditable-invalid-value' : '';
        };
        $scope.prefillOrResetOtherAdress = function () {
            if (companyHasOtherAddressFilter($scope.company.fakturacniAdresa)) {
                that.resetOtherAddress();
            } else {
                that.prefillOtherAddress();
            }
        };
        $scope.okClicked = function () {
            $timeout(function () {
                var missingRequiredFields = elfiumMissingRequiredFieldsFilter($scope.company, COMPANY_REQUIRED_FIELDS);
                if (missingRequiredFields.length) {
                    elfiumToastrService.error('Vyplňte povinné údaje: ' + missingRequiredFields.join(', '));
                } else if ($scope.isZkratkaFieldValueNotUnique) {
                    elfiumToastrService.error('Stejné pole zkratka již existuje u jiné firmy');
                } else {
                    that.upsertCompany();
                }
            });
        };
        $scope.delete = function () {
            $timeout(function () {
                companyService.deleteCompany($scope.company.id).then(function () {
                    elfiumToastrService.success('Firma byla smazána!');
                    $uibModalInstance.close();
                }, elfiumToastrService.error);
            });
        };
        that.initializeWatches = function () {
            $scope.$watch('company.zkratka', function (newValue) {
                if (newValue) {
                    that.checkIfZkratkaValueUnique(newValue);
                }
            });
            $scope.$watch('company.adresa.zeme', function (newValue) {                
                that.setKrajOptionsForCountry('adresa', newValue);
            });
            $scope.$watch('company.fakturacniAdresa.zeme', function (newValue) {
                that.setKrajOptionsForCountry('fakturacniAdresa', newValue);
            });
            $scope.$watchCollection('company.fakturacniAdresa', function () {
                $scope.hasOtherAddress = companyHasOtherAddressFilter($scope.company.fakturacniAdresa);
            });
        };
        
        that.init();
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/company/companyDetailModalController.ts